import { ApiClient,API_ROUTE } from "./ApiClient";

const MediaController = {
    get: (entityType: 'Aliment' | 'Recipe', entityID: number) => {
        let url = `${entityType}/${entityID}/image`;
        return ApiClient.getImage(url);
    },
    post: async (entityType: 'Aliment' | 'Recipe', entityID: number, image: any) => {
        let url = `${entityType}/${entityID}/image`;
        var response = await ApiClient.uploadImage(url, image);

        if ('caches' in window) {
            const fullUrl = `${API_ROUTE}/${url}`;
            caches.open('ad-nutrition-cache-v1').then((cache) => {
                cache.delete(fullUrl);
            });
        }

        return response;
    }
};
export default MediaController;